import { render, staticRenderFns } from "./_SelectDaysHeader.vue?vue&type=template&id=01a0ba72"
import script from "./_SelectDaysHeader.vue?vue&type=script&lang=js"
export * from "./_SelectDaysHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports